export { default } from "./createChainedFunction.js";